import decode from 'jwt-decode';
import authTypes from 'state/ducks/auth/types';

function getUserInfoFromJwt(jwtStr) {
  const jwt = decode(jwtStr);
  return jwt; // return all for now TODO get firstName etc...
}

export default function user(state = {}, action) {
  switch (action.type) {
    case authTypes.LOGIN_SUCCESS:
      return {
        ...state,
        ...getUserInfoFromJwt(action.payload.access_token),
      };

    case authTypes.LOGOUT_REQUEST:
      return {};

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/ducks/user/reducers.js